export default __webpack_public_path__ + "static/media/icon-course-in-progress.d9d012f6.svg";